<template>
  <lay-config-provider locale="zh_CN">
      <router-view/>
  </lay-config-provider>
</template>

<style>
</style>

<script>
</script>
